import React from 'react';
import PropTypes from 'prop-types';
import SeoLandingPage from '@components/seo-landing-page';

const page = {
  seoTitle: 'Developpeur Mobile Senior a Paris | Hedi Hidouri',
  seoDescription:
    'Developpeur mobile senior a Paris pour Android, iOS, Flutter et Kotlin Multiplatform. J aide les equipes produit a livrer plus vite avec une architecture fiable et une CI/CD solide.',
  overline: 'Developpeur Mobile Senior',
  heading: 'Developpeur mobile senior a Paris pour des produits a fort impact',
  intro: [
    'J accompagne des equipes produit et engineering qui ont besoin d un profil senior pour livrer des applications Android et iOS robustes.',
    'Mon intervention couvre les decisions d architecture, l acceleration du delivery, la qualite logicielle et la securisation des parcours critiques.',
  ],
  offerTitle: 'Ce que je livre',
  offerItems: [
    'Cadrage et modernisation d architecture mobile (Clean Architecture, MVVM, MVI).',
    'Delivery de fonctionnalites Android et iOS avec ownership clair.',
    'Strategie cross-platform via Flutter ou Kotlin Multiplatform selon le contexte.',
    'Processus de release fiable avec CI/CD, monitoring et quality gates.',
  ],
  outcomesTitle: 'Resultats attendus',
  outcomeItems: [
    'Cycles de release plus rapides et plus predictibles.',
    'Reduction des incidents grace a une base technique plus solide.',
    'Meilleure velocite equipe avec des standards et modules plus clairs.',
    'Capacite a passer du MVP a l echelle sans dette non maitrisee.',
  ],
  primaryCta: 'Discuter de votre besoin mobile',
  secondaryCta: 'Voir le portfolio principal',
  secondaryCtaUrl: '/fr#about',
  faqTitle: 'FAQ',
  faq: [
    {
      question: 'Intervenez-vous en freelance comme developpeur mobile senior ?',
      answer:
        'Oui. J interviens en mission freelance pour piloter un stream mobile critique ou renforcer une phase strategique de delivery.',
    },
    {
      question: 'Quelles technologies couvrez-vous ?',
      answer:
        'Android, iOS, Flutter, Kotlin, Swift et Kotlin Multiplatform. Je peux aussi intervenir sur des couches backend et API orientees mobile.',
    },
    {
      question: 'Pouvez-vous integrer une equipe existante rapidement ?',
      answer:
        'Oui. Je commence generalement par un audit technique cible, puis un plan de priorites execute en iterations courtes avec l equipe.',
    },
  ],
  relatedTitle: 'Pages liees',
  relatedLinks: [
    { label: 'Consultant Flutter Kotlin iOS', url: '/fr/flutter-kotlin-ios-consultant' },
    { label: 'Experiences et parcours complet', url: '/fr#jobs' },
    { label: 'Contact et disponibilite', url: '/fr#contact' },
  ],
  serviceSchema: {
    name: 'Services Developpeur Mobile Senior',
    serviceType: 'Conseil en developpement logiciel mobile',
  },
};

const SeniorMobileDeveloperPageFr = ({ location }) => (
  <SeoLandingPage location={location} language="fr" page={page} />
);

SeniorMobileDeveloperPageFr.propTypes = {
  location: PropTypes.object.isRequired,
};

export default SeniorMobileDeveloperPageFr;
